import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

export const UserRoleHelperContent: FC = () => (
  <Stack gap="4px">
    <Typography variant="body14" color={text.primary}>
      管理者：centerのすべてにアクセス・編集可能
    </Typography>
    <Typography variant="body14" color={text.primary}>
      一般：centerのすべてにアクセス可能、ユーザー情報の編集は自身の情報のみ可
    </Typography>
  </Stack>
);
